
const { feWp } = window;
const { addAction } = feWp.hooks;

addAction(
  'b3rg_tab_slider_content_init',
  'b3rg/tab-slider',
  ( settings, swiperTabContent, contentSwiper ) => {

    const nextButton = contentSwiper.thumbs.swiper.el.querySelector( '.swiper-button-next' );
    if ( nextButton ) {
      nextButton.addEventListener( 'click', function () {
        if ( nextButton.classList.contains( 'loop-enabled' ) ) {
          contentSwiper.slideTo( 0 ); // Slides to the first slide
        }
      } );
    }

    // Enables the next button when the last slide reached
    contentSwiper.on( 'slideChange', function () {
      const isLoopEnabled = contentSwiper.loopedSlides > 0;
      const lastSlideReached = contentSwiper.realIndex + 1 === contentSwiper.slides.length;
      if ( isLoopEnabled ) {
        if ( nextButton ) {
          if ( lastSlideReached ) {
            nextButton.classList.add( 'loop-enabled' );
          } else {
            nextButton.classList.remove( 'loop-enabled' );
          }
        }
      }
    } ); 
  },
  10,
  1,
);
